import { Box, Button, Center, Table, Tbody, Td, Text, Th, Thead, Tr, VStack } from '@chakra-ui/react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { useEffect, useState } from 'react';
import { fetchActiveFacilitiesLastMonth } from '../../api';
import Loading from '../../components/Loading/Loading';

export default function ActiveFacilitiesLastMonth({ labId }) {
    // const { labId } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            setLoading(true);
            const res = await fetchActiveFacilitiesLastMonth(labId);
            if (res.success) setData(res.data);
            setLoading(false);
        })();
    }, [labId]);

    const handleExport = async () => {
        const workbook = new ExcelJS.Workbook();

        // By County Sheet
        const countySheet = workbook.addWorksheet('By County');
        countySheet.columns = [
            { header: '#', key: 'num', width: 5 },
            { header: 'County', key: 'county', width: 25 },
            { header: 'Facilities', key: 'facilityCount', width: 12 },
            { header: 'Pickups', key: 'pickups', width: 10 },
            { header: 'Samples', key: 'samples', width: 10 },
        ];
        Object.entries(data.byCounty).forEach(([county, d], idx) => {
            countySheet.addRow({
                num: idx + 1,
                county,
                facilityCount: d.facilityCount,
                pickups: d.pickups,
                samples: d.samples,
            });
        });

        // By City Sheet
        const citySheet = workbook.addWorksheet('By City');
        citySheet.columns = [
            { header: '#', key: 'num', width: 5 },
            { header: 'City', key: 'city', width: 20 },
            { header: 'County', key: 'county', width: 25 },
            { header: 'Facilities', key: 'facilityCount', width: 12 },
            { header: 'Pickups', key: 'pickups', width: 10 },
            { header: 'Samples', key: 'samples', width: 10 },
        ];
        Object.entries(data.byCity).forEach(([city, d], idx) => {
            citySheet.addRow({
                num: idx + 1,
                city: city.charAt(0).toUpperCase() + city.slice(1),
                county: d.county,
                facilityCount: d.facilityCount,
                pickups: d.pickups,
                samples: d.samples,
            });
        });

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), `ActiveFacilities_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };

    if (loading) return <Center mt="20%"><Loading /></Center>;

    return (
        <Box maxW="5xl" mx="auto" p="8">
            <VStack spacing={10} align="stretch">
                <Text fontWeight="bold" fontSize="2xl">Active Facilities (Pickups in Last Month)</Text>
                <Button onClick={handleExport} colorScheme="teal" mb={4} alignSelf="flex-end">Export to Excel</Button>
                {/* By County */}
                <Box>
                    <Text fontWeight="bold" fontSize="lg" mb={2}>By County</Text>
                    <Box border="1px solid #ddd" borderRadius="md" maxH="350px" overflowY="auto">
                        <Table size="sm">
                            <Thead>
                                <Tr>
                                    <Th>#</Th>
                                    <Th>County</Th>
                                    <Th isNumeric>Facilities</Th>
                                    <Th isNumeric>Pickups</Th>
                                    <Th isNumeric>Samples</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {Object.entries(data.byCounty).map(([county, d], idx) => (
                                    <Tr key={county}>
                                        <Td>{idx + 1}</Td>
                                        <Td>{county}</Td>
                                        <Td isNumeric>{d.facilityCount}</Td>
                                        <Td isNumeric>{d.pickups}</Td>
                                        <Td isNumeric>{d.samples}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </Box>
                </Box>
                {/* By City */}
                <Box>
                    <Text fontWeight="bold" fontSize="lg" mb={2}>By City</Text>
                    <Box border="1px solid #ddd" borderRadius="md" maxH="350px" overflowY="auto">
                        <Table size="sm">
                            <Thead>
                                <Tr>
                                    <Th>#</Th>
                                    <Th>City</Th>
                                    <Th>County</Th>
                                    <Th isNumeric>Facilities</Th>
                                    <Th isNumeric>Pickups</Th>
                                    <Th isNumeric>Samples</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {Object.entries(data.byCity).map(([city, d], idx) => (
                                    <Tr key={city}>
                                        <Td>{idx + 1}</Td>
                                        <Td>{city.charAt(0).toUpperCase() + city.slice(1)}</Td>
                                        <Td>{d.county}</Td>
                                        <Td isNumeric>{d.facilityCount}</Td>
                                        <Td isNumeric>{d.pickups}</Td>
                                        <Td isNumeric>{d.samples}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </Box>
                </Box>
            </VStack>
        </Box>
    );
}
